import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth, hasRole } from "@/context/AuthContext.jsx";

export default function ProtectedRoute({ children, allow = ["superadmin", "backoffice", "user", "viewer"] }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-center">Lade…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!hasRole(user, allow)) {
    // cad_uploader has its own portal; redirect there instead of the dashboard
    if (user.role === "cad_uploader") return <Navigate to="/cad-portal" replace />;
    return <Navigate to="/" replace />;
  }
  return children;
}
